import { render, staticRenderFns } from "./commonTitle.vue?vue&type=template&id=a706e92a&scoped=true"
import script from "./commonTitle.vue?vue&type=script&lang=js"
export * from "./commonTitle.vue?vue&type=script&lang=js"
import style0 from "./commonTitle.vue?vue&type=style&index=0&id=a706e92a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a706e92a",
  null
  
)

export default component.exports